'use strict';
var lastTime = Date.now();

module.exports = {
  tic: function() {
    lastTime = Date.now();
  },
  toc: function () {
    return Date.now() - lastTime;
  },
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/basics/timer.js
 ** module id = 121
 ** module chunks = 0
 **/